/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Msg_Account_Type_SavedInputs */

const en_msg_account_type_saved = /** @type {(inputs: Msg_Account_Type_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account type saved successfully.`)
};

const es_msg_account_type_saved = /** @type {(inputs: Msg_Account_Type_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de cuenta guardado con éxito.`)
};

const fr_msg_account_type_saved = /** @type {(inputs: Msg_Account_Type_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type de compte enregistré avec succès.`)
};

const de_msg_account_type_saved = /** @type {(inputs: Msg_Account_Type_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontotyp erfolgreich gespeichert.`)
};

const id_msg_account_type_saved = /** @type {(inputs: Msg_Account_Type_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jenis akun berhasil disimpan.`)
};

/** @type {(inputs: Msg_Account_Type_SavedInputs) => LocalizedString} */
const ja_msg_account_type_saved = en_msg_account_type_saved;

/** @type {(inputs: Msg_Account_Type_SavedInputs) => LocalizedString} */
const zh_msg_account_type_saved = en_msg_account_type_saved;

/** @type {(inputs: Msg_Account_Type_SavedInputs) => LocalizedString} */
const ar_msg_account_type_saved = en_msg_account_type_saved;

/** @type {(inputs: Msg_Account_Type_SavedInputs) => LocalizedString} */
const it_msg_account_type_saved = en_msg_account_type_saved;

/** @type {(inputs: Msg_Account_Type_SavedInputs) => LocalizedString} */
const ru_msg_account_type_saved = en_msg_account_type_saved;

/** @type {(inputs: Msg_Account_Type_SavedInputs) => LocalizedString} */
const pt_msg_account_type_saved = en_msg_account_type_saved;

/** @type {(inputs: Msg_Account_Type_SavedInputs) => LocalizedString} */
const ko_msg_account_type_saved = en_msg_account_type_saved;

/**
* | output |
* | --- |
* | "Account type saved successfully." |
*
* @param {Msg_Account_Type_SavedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const msg_account_type_saved = /** @type {((inputs?: Msg_Account_Type_SavedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Msg_Account_Type_SavedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_msg_account_type_saved(inputs)
	if (locale === "es") return es_msg_account_type_saved(inputs)
	if (locale === "fr") return fr_msg_account_type_saved(inputs)
	if (locale === "de") return de_msg_account_type_saved(inputs)
	if (locale === "ja") return ja_msg_account_type_saved(inputs)
	if (locale === "zh") return zh_msg_account_type_saved(inputs)
	if (locale === "ar") return ar_msg_account_type_saved(inputs)
	if (locale === "id") return id_msg_account_type_saved(inputs)
	if (locale === "it") return it_msg_account_type_saved(inputs)
	if (locale === "ru") return ru_msg_account_type_saved(inputs)
	if (locale === "pt") return pt_msg_account_type_saved(inputs)
	return ko_msg_account_type_saved(inputs)
});